// SUMMARY: Supported locales and the cookie used to persist a user's explicit choice

export const LOCALES = ['de', 'en'] as const
export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'de'
export const LOCALE_COOKIE = 'shipman.locale'

export function isLocale(value: unknown): value is Locale {
	return typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
}
